module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av636-e4b5a06ea7571880ed07c1046805955a.jpg";